/* eslint-disable react/prop-types */
import './index.scss';
import ModalBase from '.';
import { ModalProps } from '../../types';

function ModalSuccess({ modalIsOpen, setIsOpen }: ModalProps) {
  function closeModal() {
    setIsOpen(false);
  }

  const ModalChildren = () => {
    const onButtonClick = async (e: { preventDefault: () => void }) => {
      e.preventDefault();
      closeModal();
    };

    return (
      <div className={`modal-base  general success flex--4`}>
        <span onClick={closeModal}>&times;</span>
        {/* <img src="/images/successJ.svg" /> */}
        <form onSubmit={onButtonClick}>
          <h4>Success!</h4>
          <p>You have successfully joined the Target</p>
          <button type="submit">Close</button>
        </form>
      </div>
    );
  };

  return (
    <ModalBase modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}>
      <ModalChildren />
    </ModalBase>
  );
}

export default ModalSuccess;
